<template>
    <div class="profil">
        <div class="top-background-bloc"></div>
        <div class="pro-main-title">
            <div class="pt-5 pb-5 header w-100">
                <h1 class="mx-auto col-11">Mon profil</h1>
            </div>

            <div class="pro-main-container-bloc pt-5">
                <div class="mx-auto col-11">
                    <div class="d-flex justify-content-between">
                        <div class="flex-grow-1 mr-4">
                            <v-label>Nom</v-label>
                            <v-text-field outlined v-model="contactData.last_name"></v-text-field>
                        </div>

                        <div class="flex-grow-1 ml-4">
                            <v-label>Prénom</v-label>
                            <v-text-field outlined v-model="contactData.first_name"></v-text-field>
                        </div>
                    </div>

                    <div>
                        <v-label>Fonction</v-label>
                        <v-select :items="professions"
                                  outlined
                                  v-model="contactData.profession"
                                  item-text="label"
                                  return-object>
                        </v-select>
                    </div>

                    <div class="mt-auto mb-auto text-center">
                        <v-btn class="default-button text-none" @click="updateContact">
                            <span>Enregistrer</span>
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "ProProfil",
    data() {
        return {
            professions: [],
            loading: false,
            contactData: {}
        }
    },
    methods: {
        getProfessions() {
            this.$http.get('resource/professions').then(res => {
                this.professions = res.body.data.professions
            })
        },
        updateContact() {
            let payload = {
                contact: this.contactData
            }

            this.loading = true

            this.$http.post('professional/contact', payload).then(res => {
                this.$store.dispatch('pro/fetchContact', this.contact.token)

                this.loading = false
            })
        }
    },
    computed: {
        ...mapState('pro', ['contact'])
    },
    created() {
        this.getProfessions()

        this.contactData = JSON.parse(JSON.stringify(this.contact))
    }
}
</script>